const fragment = `
  id
  price
  isDefault
  package {
    id
    name
    imageUrl
  }
  buildingModel {
    id
    name
  }
`;

export const listBuildingModelPackagesQuery = `
  query ListBuildingModelPackages(
    $filter: BuildingModelPackageFilterInput
  ) {
    items: listBuildingModelPackages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createBuildingModelPackageQuery = `
  mutation CreateBuildingModelPackage(
    $input: CreateBuildingModelPackageInput!
  ) {
    item: createBuildingModelPackage(input: $input) {
      ${fragment}
    }
  }
`;

export const updateBuildingModelPackageQuery = `
  mutation UpdateBuildingModelPackage(
    $input: UpdateBuildingModelPackageInput!
  ) {
    item: updateBuildingModelPackage(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteBuildingModelPackageQuery = `
  mutation DeleteBuildingModelPackage(
    $id: Int!
  ) {
    item: deleteBuildingModelPackage(id: $id) {
      ${fragment}
    }
  }
`;
